import React from 'react';
import styled from 'styled-components';

import useCart from 'src/hooks/use-cart';
import { isNotNullish } from 'shared/utils/type-utils';
import { scheduledOrderingEnabledForDelivery } from 'shared/helpers/dispensaries';

import { Clock } from 'src/assets/clock';

export const DeliveryEstimate = (): JSX.Element | null => {
  const { dispensary, durationEstimates, isDelivery, simplifiedOrderType, isEmpty } = useCart();

  if (
    isEmpty ||
    !dispensary ||
    !isDelivery ||
    !simplifiedOrderType ||
    dispensary.featureFlags?.hideDeliveryEstimate ||
    !durationEstimates?.[simplifiedOrderType]
  ) {
    return null;
  }

  const offerDelivery = dispensary?.orderTypesConfigV2?.offerDeliveryService;
  const scheduledOrderingForDelivery = scheduledOrderingEnabledForDelivery(dispensary);

  if (!offerDelivery || scheduledOrderingForDelivery) {
    return null;
  }

  const { lowInMinutes, highInMinutes } = durationEstimates[simplifiedOrderType];

  const validEstimates = [lowInMinutes, highInMinutes].filter(isNotNullish);

  const estimate = validEstimates.join(' - ');

  if (!estimate) {
    return null;
  }

  return (
    <Wrapper data-testid='delivery-estimate'>
      <ClockIcon />
      Delivery Estimate: {estimate} minutes
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  gap: 12px;
  line-height: 1;
  margin-top: 8px;
  width: 100%;
`;

const ClockIcon = styled(Clock)`
  color: #485055;
  flex-shrink: 0;
`;
